<template>
  <div>
    <AppLayout title="Orçamentos">
      <template #actions>
        <div class="d-flex gap-2">
          <button type="button" class="btn btn-primary btn-sm" @click="abrirNovoOrcamento()">
            <i class="bi bi-plus-lg me-1"></i>Novo orçamento
          </button>
          <div class="btn-group">
            <button v-for="opt in filtros" :key="opt.value" type="button"
              class="btn btn-sm" :class="filtroAtivo === opt.value ? 'btn-primary' : 'btn-outline-secondary'"
              @click="mudarFiltro(opt.value)">{{ opt.label }}</button>
          </div>
        </div>
      </template>

      <div v-if="avisoAgendamento" class="alert alert-warning alert-dismissible">
        {{ avisoAgendamento }}
        <button type="button" class="btn-close" @click="avisoAgendamento = null"></button>
      </div>

      <div class="table-card">
        <table class="table">
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Data</th>
              <th>Total</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="orcamento in lista_orcamentos" :key="orcamento.id">
              <td>{{ orcamento.customer?.name ?? 'Avulso' }}</td>
              <td>{{ formatter.dateTime(orcamento.created_at) }}</td>
              <td>{{ formatter.currency(orcamento.total) }}</td>
              <td>
                <span class="badge" :class="statusBadge(orcamento.status)">{{ statusLabel(orcamento.status) }}</span>
              </td>
              <td style="width:40px">
                <button @click="abrirDetalhe(orcamento)" type="button" class="btn btn-info btn-sm" title="Ver detalhes">
                  <i class="bi bi-info-square-fill"></i>
                </button>
              </td>
            </tr>
            <tr v-if="!lista_orcamentos.length">
              <td colspan="5" class="text-center text-muted">Nenhum orçamento encontrado.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <nav aria-label="Paginação de orçamentos" class="mt-3" v-if="totalPages > 1">
        <ul class="pagination justify-content-center">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="changePage(currentPage - 1)" :disabled="currentPage === 1">Anterior</button>
          </li>
          <li class="page-item" v-for="p in totalPages" :key="p" :class="{ active: p === currentPage }">
            <button class="page-link" @click="changePage(p)">{{ p }}</button>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages">Próximo</button>
          </li>
        </ul>
      </nav>
    </AppLayout>

    <!-- Modal Detalhe -->
    <div class="modal fade" id="modal_detalhe" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog modal-lg">
        <div class="modal-content" v-if="detalhe">
          <div class="modal-header">
            <h5 class="modal-title">Orçamento #{{ detalhe.id }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p class="mb-1"><strong>Cliente:</strong> {{ detalhe.customer?.name ?? 'Avulso' }}</p>
            <p class="mb-1"><strong>Emitido por:</strong> {{ detalhe.operator?.name ?? 'Dono da loja' }}</p>
            <p class="mb-3">
              <strong>Status:</strong>
              <span class="badge" :class="statusBadge(detalhe.status)">{{ statusLabel(detalhe.status) }}</span>
            </p>

            <table class="table table-sm">
              <thead>
                <tr><th>Item</th><th>Qtd</th><th>Preço</th><th>Total</th></tr>
              </thead>
              <tbody>
                <tr v-for="item in detalhe.products" :key="'p'+item.id">
                  <td>{{ item.product?.name }}</td>
                  <td>{{ item.amount }}</td>
                  <td>{{ formatter.currency(item.price_uni) }}</td>
                  <td>{{ formatter.currency(item.price_total) }}</td>
                </tr>
                <tr v-for="item in detalhe.services" :key="'s'+item.id">
                  <td>{{ item.service?.name }} <span class="badge text-bg-light border ms-1">serviço</span></td>
                  <td>{{ item.amount }}</td>
                  <td>{{ formatter.currency(item.price_uni) }}</td>
                  <td>{{ formatter.currency(item.price_total) }}</td>
                </tr>
              </tbody>
            </table>
            <p class="text-end fw-bold mb-0">Total: {{ formatter.currency(detalhe.total) }}</p>
            <p v-if="detalhe.appointment" class="text-primary small mt-2 mb-0">
              <i class="bi bi-calendar-check me-1"></i>Visita agendada para {{ formatter.dateTime(detalhe.appointment.scheduled_at) }}.
            </p>
            <p v-if="detalhe.operation_id" class="text-success small mt-2 mb-0">
              <i class="bi bi-check-circle-fill me-1"></i>Já convertido em venda.
            </p>

            <!-- Aprovar já converte o orçamento em venda de verdade (baixa
                 estoque) — por isso pede a forma de pagamento aqui, igual
                 o fechamento de uma venda no PDV. -->
            <div v-if="aprovando" class="border rounded p-3 mt-3">
              <label class="form-label d-block">Como o cliente vai pagar?</label>
              <div class="btn-group btn-group-sm mb-2" role="group">
                <input type="radio" class="btn-check" id="modo_pagamento_full" value="full" v-model="modoPagamentoAprovacao" @change="formaPagamentoAprovacaoId = null">
                <label class="btn btn-outline-primary" for="modo_pagamento_full">Integral</label>

                <input type="radio" class="btn-check" id="modo_pagamento_half" value="half" v-model="modoPagamentoAprovacao"
                  :disabled="!detalhe.customer_id" @change="formaPagamentoAprovacaoId = null">
                <label class="btn btn-outline-primary" for="modo_pagamento_half">50% agora + 50% na conta</label>
              </div>
              <p v-if="!detalhe.customer_id" class="text-muted small">O pagamento em 50% só está disponível para orçamento com cliente vinculado.</p>

              <label class="form-label">Forma de pagamento{{ modoPagamentoAprovacao === 'half' ? ' dos 50% pagos agora' : '' }}:</label>
              <select v-model="formaPagamentoAprovacaoId" class="form-select form-select-sm">
                <option :value="null" disabled>Selecione...</option>
                <option v-for="fp in formasPagamentoParaAprovacao" :key="fp.id" :value="fp.id">{{ fp.name }}</option>
              </select>
              <p v-if="modoPagamentoAprovacao === 'half'" class="text-muted small mt-2 mb-0">
                {{ formatter.currency(detalhe.total / 2) }} agora nessa forma, {{ formatter.currency(detalhe.total / 2) }} vão para a conta de {{ detalhe.customer?.name }}.
              </p>

              <div v-if="erroAprovacao" class="text-danger small mt-2">{{ erroAprovacao }}</div>
              <div class="d-flex gap-2 mt-3">
                <button type="button" @click="aprovando = false" class="btn btn-outline-secondary btn-sm">Cancelar</button>
                <button type="button" @click="confirmarAprovacao" class="btn btn-success btn-sm" :disabled="!formaPagamentoAprovacaoId || aprovandoSalvando">
                  {{ aprovandoSalvando ? 'Aprovando...' : 'Confirmar aprovação' }}
                </button>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" @click="imprimirDetalhe()" class="btn btn-outline-secondary me-auto">
              <i class="bi bi-printer me-1"></i>Imprimir
            </button>
            <template v-if="detalhe.status === 'pending' && !aprovando">
              <button type="button" @click="recusar" class="btn btn-outline-danger">Recusar</button>
              <button type="button" @click="iniciarAprovacao" class="btn btn-success">Aprovar</button>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Novo Orçamento -->
    <div class="modal fade" id="modal_novo_orcamento" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Novo orçamento</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3" v-if="lista_lojas.length > 1">
              <label class="form-label">Loja:</label>
              <select v-model="selectedStoreId" class="form-select">
                <option v-for="loja in lista_lojas" :key="loja.id" :value="loja.id">{{ loja.name }}</option>
              </select>
            </div>
            <div class="mb-3">
              <label class="form-label">Cliente:</label>
              <div class="row g-2">
                <div class="col-10">
                  <input type="text" v-model="buscaCliente" @input="filtrarClientes" class="form-control" placeholder="Pesquisar cliente (opcional)" autocomplete="off">
                </div>
                <div class="col-2 d-grid">
                  <button type="button" @click="limparClienteNovoOrcamento()" class="btn btn-outline-danger"><i class="bi bi-x-lg"></i></button>
                </div>
              </div>
              <div class="budget-suggestions" v-if="sugestoesClientes.length">
                <div class="budget-suggestions__item" v-for="c in sugestoesClientes" :key="c.id" @click="selecionarCliente(c)">{{ c.name }}</div>
              </div>
              <span class="text-muted small">Selecionado: <strong>{{ clienteSelecionado?.name ?? 'Avulso' }}</strong></span>
            </div>

            <div class="mb-3">
              <label class="form-label">Itens:</label>
              <input type="text" v-model="buscaItem" @input="filtrarItens" class="form-control" placeholder="Buscar produto ou serviço..." autocomplete="off">
              <div class="budget-suggestions" v-if="sugestoesItens.length">
                <div class="budget-suggestions__item" v-for="i in sugestoesItens" :key="i.type + '-' + i.id" @click="selecionarItem(i)">
                  {{ i.name }} <span v-if="i.type === 'service'" class="badge text-bg-light border">serviço</span>
                  — {{ formatter.currency(i.price) }}
                </div>
              </div>
            </div>

            <table class="table table-sm" v-if="itensNovoOrcamento.length">
              <thead>
                <tr><th>Item</th><th style="width:110px">Qtd</th><th>Preço</th><th>Total</th><th></th></tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in itensNovoOrcamento" :key="item.type + '-' + item.id">
                  <td>{{ item.name }} <span v-if="item.type === 'service'" class="badge text-bg-light border">serviço</span></td>
                  <td><input type="number" min="0.01" step="0.01" v-model.number="item.quant" class="form-control form-control-sm"></td>
                  <td>{{ formatter.currency(item.price) }}</td>
                  <td>{{ formatter.currency(item.price * item.quant) }}</td>
                  <td><button type="button" @click="itensNovoOrcamento.splice(index, 1)" class="btn btn-outline-danger btn-sm"><i class="bi bi-trash3"></i></button></td>
                </tr>
              </tbody>
            </table>
            <p v-else class="text-muted small">Adicione produtos ou serviços ao orçamento.</p>

            <p class="text-end fw-bold" v-if="itensNovoOrcamento.length">Total: {{ formatter.currency(totalNovoOrcamento) }}</p>

            <div class="mb-3">
              <label class="form-label">Observações (opcional):</label>
              <textarea v-model="descricaoNovoOrcamento" class="form-control" rows="2"></textarea>
            </div>

            <!-- Agendar visita é opcional e só faz sentido com algum
                 serviço no orçamento (agendamento sempre precisa de um
                 serviço, ver AppointmentController). -->
            <div class="mb-1" v-if="servicosNoOrcamento.length">
              <div class="form-check form-switch">
                <input v-model="agendarVisita" @change="toggleAgendarVisita" class="form-check-input" type="checkbox" role="switch" id="inp_agendar_visita_orcamento">
                <label class="form-check-label" for="inp_agendar_visita_orcamento">Agendar visita para este orçamento</label>
              </div>
              <div v-if="agendarVisita" class="row g-2 mt-1">
                <div class="col-12" v-if="servicosNoOrcamento.length > 1">
                  <label class="form-label small">Serviço:</label>
                  <select v-model="agendamentoServicoId" @change="atualizarDuracaoAgendamento" class="form-select form-select-sm">
                    <option v-for="s in servicosNoOrcamento" :key="s.id" :value="s.id">{{ s.name }}</option>
                  </select>
                </div>
                <div class="col">
                  <label class="form-label small">Data e hora:</label>
                  <input v-model="agendamentoData" type="datetime-local" class="form-control form-control-sm">
                </div>
                <div class="col">
                  <label class="form-label small">Duração (min):</label>
                  <input v-model="agendamentoDuracao" type="number" min="1" class="form-control form-control-sm">
                </div>
              </div>
            </div>
            <div v-if="erroNovoOrcamento" class="text-danger small mt-2">{{ erroNovoOrcamento }}</div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
            <button type="button" @click="criarOrcamento()" class="btn btn-primary" :disabled="!itensNovoOrcamento.length || salvandoNovoOrcamento">
              {{ salvandoNovoOrcamento ? 'Emitindo...' : 'Emitir orçamento' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Recibo de orçamento pra impressão — escondido na tela, só aparece
         no diálogo de impressão do navegador (ver bloco @media print no
         <style> não-escopado abaixo). -->
    <div id="orcamento-impressao" v-if="reciboOrcamento" class="orcamento-print">
      <div class="orcamento-print__header">
        <h1>Orçamento nº {{ reciboOrcamento.id }}</h1>
      </div>
      <div class="orcamento-print__meta">
        <div><strong>Data:</strong> {{ formatter.dateTime(reciboOrcamento.date) }}</div>
        <div><strong>Cliente:</strong> {{ reciboOrcamento.cliente ?? 'Avulso' }}</div>
        <div><strong>Emitido por:</strong> {{ reciboOrcamento.operator }}</div>
        <div><strong>Status:</strong> {{ reciboOrcamento.status }}</div>
        <div v-if="reciboOrcamento.validoAte"><strong>Válido até:</strong> {{ formatter.date(reciboOrcamento.validoAte) }}</div>
      </div>
      <table class="orcamento-print__table">
        <thead>
          <tr><th>Item</th><th>Qtd</th><th>Preço</th><th>Total</th></tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in reciboOrcamento.itens" :key="index">
            <td>{{ item.name }}<span v-if="item.servico"> (serviço)</span></td>
            <td>{{ item.quant }}</td>
            <td>{{ formatter.currency(item.price) }}</td>
            <td>{{ formatter.currency(item.total) }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr><td colspan="3" class="text-end">Total</td><td>{{ formatter.currency(reciboOrcamento.total) }}</td></tr>
        </tfoot>
      </table>
      <p v-if="reciboOrcamento.descricao" class="orcamento-print__obs"><strong>Observações:</strong> {{ reciboOrcamento.descricao }}</p>
      <p class="orcamento-print__footer">Este documento é um orçamento e não representa uma venda concluída.</p>
    </div>
  </div>
</template>
<script>
import { computed, nextTick, onMounted, ref } from 'vue';
import { Modal } from "bootstrap";
import AppLayout from "@/components/AppLayout.vue";
import { orcamentos } from "@/models/orcamentos";
import { clientes } from "@/models/clientes";
import { produtos } from "@/models/produtos";
import { servicos } from "@/models/servicos";
import { lojas } from "@/models/lojas";
import { agenda } from "@/models/agenda";
import { formasDePagamento } from "@/models/formasDePagamento";
import formatter from "@/services/formaterService";

export default {
  name: 'BudgetsView',
  components: { AppLayout },
  setup() {
    const Orcamentos = orcamentos();
    const Clientes = clientes();
    const Produtos = produtos();
    const Servicos = servicos();
    const Lojas = lojas();
    const Agenda = agenda();
    const FormasDePagamento = formasDePagamento();
    const lista_orcamentos = ref([]);
    const detalhe = ref(null);
    const currentPage = ref(1);
    const totalPages = ref(1);
    const filtroAtivo = ref('pending');
    let modalDetalhe = null;
    let modalNovoOrcamento = null;

    // ----- Aprovação (converte em venda de verdade) -----
    const formasPagamentoAtivas = ref([]);
    const aprovando = ref(false);
    const modoPagamentoAprovacao = ref('full');
    const formaPagamentoAprovacaoId = ref(null);
    const aprovandoSalvando = ref(false);
    const erroAprovacao = ref(null);

    // No modo "50%", a metade paga agora não pode ser fiado — a outra
    // metade já vai pra conta do cliente automaticamente (ver approve()
    // no backend).
    const formasPagamentoParaAprovacao = computed(() => modoPagamentoAprovacao.value === 'half'
      ? formasPagamentoAtivas.value.filter(fp => fp.type !== 'onaccount')
      : formasPagamentoAtivas.value);

    // ----- Novo orçamento -----
    const lista_lojas = ref([]);
    const selectedStoreId = ref(null);
    const listaClientes = ref([]);
    const catalogo = ref([]); // produtos + serviços, pra busca do item
    const buscaCliente = ref('');
    const sugestoesClientes = ref([]);
    const clienteSelecionado = ref(null);
    const buscaItem = ref('');
    const sugestoesItens = ref([]);
    const itensNovoOrcamento = ref([]);
    const descricaoNovoOrcamento = ref('');
    const salvandoNovoOrcamento = ref(false);
    const erroNovoOrcamento = ref(null);
    const totalNovoOrcamento = computed(() => itensNovoOrcamento.value.reduce((soma, item) => soma + item.price * item.quant, 0));

    // "Agendar visita" — opcional, só existe quando o orçamento tem algum
    // serviço (agendamento sempre precisa de um serviço, ver
    // AppointmentController).
    const agendarVisita = ref(false);
    const agendamentoServicoId = ref(null);
    const agendamentoData = ref('');
    const agendamentoDuracao = ref(60);
    const avisoAgendamento = ref(null);

    const servicosNoOrcamento = computed(() => {
      const vistos = new Set();
      return itensNovoOrcamento.value
        .filter(item => item.type === 'service' && !vistos.has(item.id) && vistos.add(item.id))
        .map(item => ({ id: item.id, name: item.name }));
    });

    function toggleAgendarVisita() {
      if (!agendarVisita.value) return;
      agendamentoServicoId.value = servicosNoOrcamento.value[0]?.id ?? null;
      atualizarDuracaoAgendamento();
    }

    function atualizarDuracaoAgendamento() {
      const servico = catalogo.value.find(i => i.type === 'service' && i.id === agendamentoServicoId.value);
      agendamentoDuracao.value = servico?.duration_minutes ?? 60;
    }

    // ----- Impressão -----
    const reciboOrcamento = ref(null);

    const filtros = [
      { value: 'pending', label: 'Pendentes' },
      { value: 'approved', label: 'Aprovados' },
      { value: 'rejected', label: 'Recusados' },
      { value: null, label: 'Todos' },
    ];

    function statusLabel(status) {
      return { pending: 'Pendente', approved: 'Aprovado', rejected: 'Recusado' }[status] ?? status;
    }

    function statusBadge(status) {
      return {
        pending: 'text-bg-warning',
        approved: 'text-bg-success',
        rejected: 'text-bg-danger',
      }[status] ?? 'text-bg-secondary';
    }

    const refresh = async (page = 1) => {
      const resultado = await Orcamentos.list(page, filtroAtivo.value);
      if (resultado) {
        lista_orcamentos.value = resultado.data ?? [];
        totalPages.value = resultado.pages || 1;
        currentPage.value = resultado.page || 1;
      }
    };

    const mudarFiltro = (status) => {
      filtroAtivo.value = status;
      refresh(1);
    };

    const changePage = (page) => {
      if (page < 1 || page > totalPages.value) return;
      refresh(page);
    };

    const abrirDetalhe = async (orcamento) => {
      detalhe.value = await Orcamentos.show(orcamento.id);
      aprovando.value = false;
      modalDetalhe = modalDetalhe ?? new Modal(document.getElementById('modal_detalhe'));
      modalDetalhe.show();
    };

    const iniciarAprovacao = () => {
      erroAprovacao.value = null;
      formaPagamentoAprovacaoId.value = null;
      modoPagamentoAprovacao.value = 'full';
      aprovando.value = true;
    };

    const confirmarAprovacao = async () => {
      erroAprovacao.value = null;
      aprovandoSalvando.value = true;
      const ok = await Orcamentos.approve(detalhe.value.id, formaPagamentoAprovacaoId.value, modoPagamentoAprovacao.value);
      aprovandoSalvando.value = false;

      if (!ok) {
        erroAprovacao.value = Orcamentos.lastErrorMessage.value || 'Não foi possível aprovar o orçamento.';
        return;
      }

      aprovando.value = false;
      modalDetalhe.hide();
      refresh(currentPage.value);
    };

    const recusar = async () => {
      if (await Orcamentos.reject(detalhe.value.id)) {
        modalDetalhe.hide();
        refresh(currentPage.value);
      }
    };

    // ----- Novo orçamento -----

    function limparClienteNovoOrcamento() {
      buscaCliente.value = '';
      sugestoesClientes.value = [];
      clienteSelecionado.value = null;
    }

    function filtrarClientes() {
      const termo = buscaCliente.value.trim().toLowerCase();
      sugestoesClientes.value = termo
        ? listaClientes.value.filter(c => c.name.toLowerCase().includes(termo)).slice(0, 8)
        : [];
    }

    function selecionarCliente(cliente) {
      clienteSelecionado.value = cliente;
      buscaCliente.value = '';
      sugestoesClientes.value = [];
    }

    function filtrarItens() {
      const termo = buscaItem.value.trim().toLowerCase();
      sugestoesItens.value = termo
        ? catalogo.value.filter(i => i.name.toLowerCase().includes(termo)).slice(0, 8)
        : [];
    }

    function selecionarItem(item) {
      // Produto e serviço podem repetir o mesmo id numérico (tabelas
      // diferentes) — junta pelo par (id, type), igual o carrinho do PDV.
      const existente = itensNovoOrcamento.value.find(i => i.id === item.id && i.type === item.type);
      if (existente) {
        existente.quant += 1;
      } else {
        itensNovoOrcamento.value.push({ id: item.id, type: item.type, name: item.name, price: item.price, quant: 1 });
      }
      buscaItem.value = '';
      sugestoesItens.value = [];
    }

    async function abrirNovoOrcamento() {
      erroNovoOrcamento.value = null;
      limparClienteNovoOrcamento();
      buscaItem.value = '';
      sugestoesItens.value = [];
      itensNovoOrcamento.value = [];
      descricaoNovoOrcamento.value = '';
      agendarVisita.value = false;
      agendamentoServicoId.value = null;
      agendamentoData.value = '';
      agendamentoDuracao.value = 60;

      const [clientesResp, produtosResp, servicosResp] = await Promise.all([
        Clientes.list(),
        Produtos.listAll(),
        Servicos.list(),
      ]);
      listaClientes.value = clientesResp ?? [];
      catalogo.value = [
        ...(produtosResp ?? []).map(p => ({ ...p, type: 'product' })),
        ...(servicosResp ?? []).map(s => ({ ...s, type: 'service' })),
      ];

      modalNovoOrcamento = modalNovoOrcamento ?? new Modal(document.getElementById('modal_novo_orcamento'));
      modalNovoOrcamento.show();
    }

    async function criarOrcamento() {
      erroNovoOrcamento.value = null;
      salvandoNovoOrcamento.value = true;
      const criado = await Orcamentos.create({
        customer_id: clienteSelecionado.value?.id ?? null,
        store_id: selectedStoreId.value,
        description: descricaoNovoOrcamento.value || null,
        items: itensNovoOrcamento.value.map(item => ({
          type: item.type, id: item.id, quant: item.quant, price: item.price,
        })),
      });
      salvandoNovoOrcamento.value = false;

      if (!criado) {
        erroNovoOrcamento.value = Orcamentos.lastErrorMessage.value || 'Erro ao emitir orçamento.';
        return;
      }

      avisoAgendamento.value = null;
      if (agendarVisita.value && agendamentoServicoId.value && agendamentoData.value) {
        const agendamentoCriado = await Agenda.createItem({
          budget_id: criado.id,
          store_id: selectedStoreId.value,
          service_id: agendamentoServicoId.value,
          customer_id: clienteSelecionado.value?.id ?? null,
          scheduled_at: agendamentoData.value,
          duration_minutes: agendamentoDuracao.value,
        });
        if (agendamentoCriado !== true) {
          avisoAgendamento.value = typeof agendamentoCriado === 'string'
            ? agendamentoCriado
            : 'Orçamento emitido, mas não foi possível agendar a visita.';
        }
      }

      filtroAtivo.value = 'pending';
      await refresh(1);

      // Espera o modal de criação terminar de fechar antes de abrir o de
      // detalhe — os dois ao mesmo tempo bagunça o backdrop do Bootstrap.
      document.getElementById('modal_novo_orcamento').addEventListener('hidden.bs.modal', () => {
        // Já abre o detalhe do que acabou de emitir — é ali que dá pra
        // aprovar/recusar e imprimir.
        abrirDetalhe(criado);
      }, { once: true });
      modalNovoOrcamento.hide();
    }

    // ----- Impressão -----

    function montarReciboOrcamento(orcamento) {
      reciboOrcamento.value = {
        id: orcamento.id,
        date: orcamento.created_at,
        operator: orcamento.operator?.name ?? 'Dono da loja',
        cliente: orcamento.customer?.name ?? null,
        status: statusLabel(orcamento.status),
        validoAte: orcamento.valid_until,
        descricao: orcamento.description,
        itens: [
          ...(orcamento.products ?? []).map(p => ({
            name: p.product?.name, quant: p.amount, price: p.price_uni, total: p.price_total, servico: false,
          })),
          ...(orcamento.services ?? []).map(s => ({
            name: s.service?.name, quant: s.amount, price: s.price_uni, total: s.price_total, servico: true,
          })),
        ],
        total: orcamento.total,
      };
    }

    function imprimirDetalhe() {
      montarReciboOrcamento(detalhe.value);
      // O bloco de impressão só existe no DOM depois do v-if virar true —
      // sem esperar o próximo tick, window.print() podia disparar antes
      // do Vue renderizar o conteúdo novo.
      nextTick(() => window.print());
    }

    onMounted(async () => {
      refresh();
      lista_lojas.value = await Lojas.list();
      selectedStoreId.value = (lista_lojas.value.find(l => l.is_default) ?? lista_lojas.value[0])?.id ?? null;
      const formasResp = await FormasDePagamento.list();
      formasPagamentoAtivas.value = (formasResp ?? []).filter(fp => fp.active);
    });

    return {
      lista_orcamentos, detalhe, currentPage, totalPages, filtroAtivo, filtros, formatter,
      statusLabel, statusBadge, mudarFiltro, changePage, abrirDetalhe, recusar,
      formasPagamentoAtivas, formasPagamentoParaAprovacao, aprovando, modoPagamentoAprovacao,
      formaPagamentoAprovacaoId, aprovandoSalvando, erroAprovacao,
      iniciarAprovacao, confirmarAprovacao,
      lista_lojas, selectedStoreId,
      buscaCliente, sugestoesClientes, clienteSelecionado, limparClienteNovoOrcamento, filtrarClientes, selecionarCliente,
      buscaItem, sugestoesItens, filtrarItens, selecionarItem,
      itensNovoOrcamento, totalNovoOrcamento, descricaoNovoOrcamento, salvandoNovoOrcamento, erroNovoOrcamento,
      abrirNovoOrcamento, criarOrcamento,
      servicosNoOrcamento, agendarVisita, agendamentoServicoId, agendamentoData, agendamentoDuracao,
      toggleAgendarVisita, atualizarDuracaoAgendamento, avisoAgendamento,
      reciboOrcamento, imprimirDetalhe,
    };
  },
}
</script>
<style scoped>
.budget-suggestions {
  border: 1px solid var(--bs-border-color, #dee2e6);
  border-radius: 0.375rem;
  margin-top: 0.25rem;
  max-height: 220px;
  overflow-y: auto;
}

.budget-suggestions__item {
  padding: 0.5rem 0.75rem;
  cursor: pointer;
}

.budget-suggestions__item:hover {
  background-color: var(--bs-tertiary-bg, #f8f9fa);
}

.budget-suggestions__item + .budget-suggestions__item {
  border-top: 1px solid var(--bs-border-color, #dee2e6);
}
</style>

<!--
  Bloco de impressão não-escopado de propósito: a regra "esconde tudo
  menos o orçamento" precisa alcançar o <body> do documento, que fica
  fora do template deste componente e nunca receberia o atributo de
  escopo do Vue (mesmo mecanismo do recibo de venda no pdv/).
-->
<style>
  #orcamento-impressao {
    display: none;
  }

  @media print {
    body * {
      visibility: hidden;
    }

    #orcamento-impressao,
    #orcamento-impressao * {
      visibility: visible;
    }

    #orcamento-impressao {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      padding: 20mm;
    }
  }

  #orcamento-impressao.orcamento-print {
    font-family: Arial, Helvetica, sans-serif;
    color: #000;
  }

  #orcamento-impressao .orcamento-print__header {
    text-align: center;
    margin-bottom: 16px;
  }

  #orcamento-impressao .orcamento-print__header h1 {
    font-size: 20px;
    margin: 0;
  }

  #orcamento-impressao .orcamento-print__meta {
    margin-bottom: 16px;
    font-size: 13px;
  }

  #orcamento-impressao .orcamento-print__meta div {
    margin-bottom: 4px;
  }

  #orcamento-impressao .orcamento-print__table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
  }

  #orcamento-impressao .orcamento-print__table th,
  #orcamento-impressao .orcamento-print__table td {
    border: 1px solid #ccc;
    padding: 6px 8px;
    text-align: left;
  }

  #orcamento-impressao .orcamento-print__table tfoot td {
    font-weight: bold;
  }

  #orcamento-impressao .orcamento-print__obs {
    margin-top: 16px;
    font-size: 13px;
  }

  #orcamento-impressao .orcamento-print__footer {
    margin-top: 24px;
    font-size: 11px;
    color: #777;
    text-align: center;
  }
</style>
